import { useTranslation } from 'react-i18next';
import React from 'react';
import style from './index.module.css';
import { AccountModal } from '../AccountModal';
import { AccountRegisterModal } from '../AccountRegisterModal';
import { useSwitch } from '@/hooks';

export const ResetKeyModal = ({ turnOff }: { turnOff(): void }) => {
  const { t } = useTranslation();

  const { on: onRegisterModal, turnOn: turnOnRegisterModal } = useSwitch(false);
  const steps = [
    {
      handler: () => {
        turnOnRegisterModal();
      },
      textWidth: 64,
      content: (
        <div className={style.container}>
          <div className={style.description}>
            <span className={style.prefix}>{t('ResetKeyModal.18xaaw')}</span>
            {t('ResetKeyModal.flubad')}{' '}
          </div>
          <div className={style.description}>{t('ResetKeyModal.1uz5sme')}</div>
          <div className={style.description}>{t('ResetKeyModal.1qrdp8n')}</div>
        </div>
      ),
    },
  ];

  return (
    <>
      {onRegisterModal ? (
        <AccountRegisterModal isResetAccount turnOff={turnOff} />
      ) : (
        <AccountModal
          isLoading={false}
          hideSteps
          headerTitle={t('ResetKeyModal.reset-key')}
          turnOff={turnOff}
          steps={steps}
          buttonText={t('ResetKeyModal.confirm')}
        />
      )}
    </>
  );
};
